const StarryBackground = () => {
  return (
    <div>
      <div className="stars stars-xxl"></div>
      <div className="stars stars-xl"></div>
      <div className="stars stars-l"></div>
      <div className="stars stars-flash"></div>
      <div className="galaxy">
        <div className="halo halo-xxxl">
          <div className="halo halo-xxl">
            <div className="halo halo-xl">
              <div className="halo halo-l">
                <div className="halo shining">
                  <div className="moon">
                    <div className="flag">
                      <div className="flagpole"></div>
                    </div>
                    <div className="light"></div>
                    <div className="craters">
                      <div className="crater crater-1"></div>
                      <div className="crater crater-2"></div>
                      <div className="crater crater-3"></div>
                      <div className="crater crater-4"></div>
                      <div className="crater crater-5"></div>
                      <div className="crater crater-6"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StarryBackground;
